<template>
  <div>
    <div style="display: flex; align-items: flex-start">
      <sidebar style="margin-right: 20px; max-width: 200px" />
      <el-card style="width: 100%">
        <div
          slot="header"
          class="clearfix"
        >
          <span>Üzletek</span>
          <el-button
            style="float: right; margin-top: -5px;"
            type="success"
            size="small"
            @click="$router.replace('/data/shops/shops/add')"
            icon="el-icon-plus"
            v-can="'shop.create'"
          >
            Új Üzlet
          </el-button>
        </div>
        <table-filter
          v-if="config"
          :config="config"
          action="shop/fetchAll" />
        <list/>
        <template v-if="$route.meta.showAddShopDialog">
          <shop-dialog
            type="add"
          />
        </template>
        <template v-if="$route.meta.showUpdateShopDialog">
          <shop-dialog
            :shopId="$route.params.id"
            type="update"
          />
        </template>
      </el-card>
    </div>
  </div>
</template>
<script>
  import Sidebar from '../../../components/data/shops/Sidebar';
  import List from '../../../components/data/shops/shops/List';
  import ShopDialog from '../../../components/data/shops/shops/Dialog';
  import TableFilter from '../../../components/TableFilter';

  export default {
    components: {
      Sidebar,
      List,
      ShopDialog,
      TableFilter,
    },
    data() {
      return {
        config: null,
      };
    },
    methods: {
      async setConfig() {
        let shopCategories = this.$store.getters['shopCategory/shopCategories'];
        let shopChains = this.$store.getters['shopChain/shopChains'];
        let locations = this.$store.getters['location/locations'];
        let countries = this.$store.getters['country/countries'];
        let counties = this.$store.getters['county/counties'];
        let users = this.$store.getters['user/users'];
        if (!shopCategories.length) {
          await this.$store.dispatch('shopCategory/fetchAll');
          shopCategories = this.$store.getters['shopCategory/shopCategories'];
        }
        if (!shopChains.length) {
          await this.$store.dispatch('shopChain/fetchAll');
          shopChains = this.$store.getters['shopChain/shopChains'];
        }
        if (!locations.length) {
          await this.$store.dispatch('location/fetchAll');
          locations = this.$store.getters['location/locations'];
        }
        if(!countries.length) {
          await this.$store.dispatch('country/fetchAll');
          countries = this.$store.getters['country/countries'];
        }
        if(!counties.length) {
          await this.$store.dispatch('county/fetchAll');
          counties = this.$store.getters['county/counties'];
        }
        if (!users.length) {
          await this.$store.dispatch('user/fetchAll');
          users = this.$store.getters['user/users'];
        }
        this.config = [
          {
            type: 'text',
            name: 'name',
            label: 'Név',
            defaultSearch: true
          },
          {
            type: 'text',
            name: 'id',
            label: 'ID',
          },
          {
            type: 'remote',
            name: 'partner',
            label: 'Partner',
            labelCallback: partner => partner && `#${partner.id} ${partner.company.name}` || '',
            valueKey: 'id',
            remoteSearchParam: 'name',
            remoteAction: 'partner/search',
          },
          {
            type: 'text',
            name: 'address',
            label: 'Cím',
          },
          {
            type: 'select',
            name: 'shop_category_id',
            options: shopCategories,
            label: 'Kategória',
            labelCallback: category => category && `${category.name}` || '',
            valueKey: 'id',
          },
          {
            type: 'select',
            name: 'shop_chain_id',
            options: shopChains,
            label: 'Üzletlánc',
            labelCallback: shopChain => shopChain && `${shopChain.name}` || '',
            valueKey: 'id',
          },
          {
            type: 'select',
            name: 'location_id',
            options: locations,
            label: 'Terület',
            labelCallback: location => location && `${location.value}` || '',
            valueKey: 'id',
          },
          {
            type: 'select',
            name: 'country_id',
            options: countries,
            label: 'Ország',
            labelCallback: country => country && `${country.name}` || '',
            valueKey: 'id',
          },
          {
            type: 'select',
            name: 'county_id',
            options: counties,
            label: 'Megye',
            labelCallback: county => county && `${county.name}` || '',
            valueKey: 'id',
          },
          {
            type: 'text',
            name: 'postal_code',
            label: 'Irányítószám',
          },
          {
            type: 'text',
            name: 'city',
            label: 'Város',
          },
          {
            type: 'select',
            options: users,
            name: 'user_id',
            label: 'Területi képviselő',
            labelCallback: user => user && `${user.last_name} ${user.first_name} (@${user.username})` || '',
            valueKey: 'id',
          },
        ];
      }
    },
    async mounted() {
      await this.setConfig();
    }
  };
</script>
